import { SET_SITE_UPDATES, SET_SITE_UPDATE_COUNTS } from '../ActionTypes';

const initialState = {
    updateCount: 0,
    updates: [],
};

const metaReduction = (state = initialState, action) => {
    switch (action.type) {
        case SET_SITE_UPDATE_COUNTS:
            return {
                ...state,
                updateCount: action.payload,
            };
        case SET_SITE_UPDATES:
            return {
                ...state,
                updates: action.payload,
            };
        default:
            return state;
    }
};

export default metaReduction;
